import React, { useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { border, borderRadius, styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { ArrowRight } from "react-feather";

const NewsItem = ({ imageUrl, name, description, last, newsId, date }) => {
  const [isHover, setHover] = useState(false);

  const { t } = useTranslation();

  const handleMouseEnter = (e) => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  return (
    <Box
      className={`cursor-pointer relative rounded-lg`}
      style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link href={"/news/" + newsId} passHref>
        <Box
          style={{
            height: "240px",
            // marginLeft: 10,
            // marginRight: 10,
            overflow: "hidden",
            borderRadius: 6,
            position: "relative",
            zIndex: 1,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          <Box
            style={{
              width: "100%",
              height: "100%",
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transform: isHover ? "scale(1.06)" : "none",
              transition:
                "margin-bottom 0.3s ease-in-out, margin-top 0.3s ease-in-out, height 0.3s ease-in-out, box-shadow 0.3s ease-in-out, transform 0.5s ease-in-out",
            }}
          ></Box>

          <Typography
            variant="subtitle3"
            className="absolute"
            style={{
              color: "white",
              backgroundColor: "#212F3D",
              top: 20,
              left: 0,
              borderRadius: 10,
              padding: "8px 15px",
              fontSize: 14,
            }}
          >
            {date}
          </Typography>
        </Box>
      </Link>
      <Link href={"/news/" + newsId} passHref>
        <Box
          style={{
            // boxShadow: '0 0 30px rgba(31, 45, 61, 0.125)',
            borderRadius: 5,
            backgroundColor: "#fff",
            padding: 15,
            zIndex: 0,
            margin: "-10px 0px 0",
            position: "relative",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,

            background: "linear-gradient(0deg, #f8f8f8 0%, #fff 40%)",
          }}
        >
          <Typography
            variant="h3"
            className=" mt-4"
            style={{
              fontSize: 17,
              color: "#212F3D",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </Typography>
          <Box className="flex flex-row justify-center items-center">
            <Typography
              variant="body2"
              className=" text-center py-2 mr-1"
              style={{ color: "blue" }}
            >
              {t("read_more")}
            </Typography>

            <ArrowRight color={"blue"} size={"17"} />
          </Box>
          {/* <Typography variant="body2">{description}</Typography> */}
        </Box>
      </Link>
    </Box>
  );
};

export default NewsItem;
